// 同步改变state
// 按类划分
// 命名：show/hide、get/set、add/reduce...

export default {
	// 书写备注
	/**
	 * 保存行情用户的自选列表
	 * @param state
	 * @param value
	 */
	saveStockSubsData(state, value) {
		state.storeStockSubsData = value;
	}
};
